export const API_get_custom_fields_layout_path = (workspaceId: string): string =>
  `/api/v1/workspaces/${workspaceId}/fields-layout`;

export const API_delete_custom_field = ({
  workspaceId,
  customFieldId,
}: {
  workspaceId: string;
  customFieldId: string;
}): string => `/api/v1/workspaces/${workspaceId}/custom-field-templates/${customFieldId}`;

export const API_create_update_custom_field_layout = (workspaceId: string): string =>
  `/api/v1/workspaces/${workspaceId}/fields-layout`;

export const API_bulk_update_custom_field_settings = (workspaceId: string): string =>
  `/api/v1/workspaces/${workspaceId}/custom-field-templates/bulk-update-settings`;
